// extracted by mini-css-extract-plugin
export default {"filterLabel":"ActivityReps_filterLabel__SM4ge"};